import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { HeaderComponent } from "./layout/header/header.component";
import { FooterComponent } from "./layout/footer/footer.component";
import { Apiconfig } from './core/helpers/apiConfig';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { ApiService } from './core/services/api.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'site';
  isBrowser: boolean;

  constructor(
    private apiService: ApiService,
    private titleService: Title,
    private meta: Meta,
    private viewportScroller: ViewportScroller,
    private renderer: Renderer2,
    private router: Router,
    @Inject(DOCUMENT) private dom: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
        this.scrollToTop();
        this.updateCanonicalTag();
      });
    }

    
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.updateCanonicalTag();
    }
  }

  scrollToTop(): void {
    if (this.isBrowser) {
      this.viewportScroller.scrollToPosition([0, 0]);
    }
  }

  updateCanonicalTag(): void {
    if (!this.isBrowser) return;

    const canonicalURL = this.dom.location?.href || this.router.url;

    // Remove old canonical tag
    const existingCanonical = this.dom.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Add new canonical tag
    const link: HTMLLinkElement = this.renderer.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonicalURL);
    this.renderer.appendChild(this.dom.head, link);

    // Alternate language links
    const alternateLinks = [
      { href: 'https://NCare.quickiz.com/', hreflang: 'en-in' },
      { href: 'https://NCare.quickiz.com/', hreflang: 'x-default' }
    ];

    this.removeExistingAlternateLinks();

    alternateLinks.forEach(linkData => {
      const altLink: HTMLLinkElement = this.renderer.createElement('link');
      altLink.setAttribute('rel', 'alternate');
      altLink.setAttribute('href', linkData.href);
      altLink.setAttribute('hreflang', linkData.hreflang);
      this.renderer.appendChild(this.dom.head, altLink);
    });
  }

  removeExistingAlternateLinks(): void {
    if (!this.isBrowser) return;

    const existingLinks = this.dom.querySelectorAll('link[rel="alternate"]');
    existingLinks.forEach(link => link.remove());
  }
}
